import { configureStore } from '@reduxjs/toolkit';
import authSlice from './auth';
import headerSlice from './header';
import lcSlice from './layoutConfiguration';
import langSlice from './lang';
import workspaceSlice from './ workspace';
import mailboxSlice from './mailbox';
import formsSlice from './forms';
import builderFormSlice from './builder';
import imageEditorSlice from './imageEditor';
import formSignatureSlice from './formSignature';
import listsSlice from './lists';
import activeListSlice from './activeList';
import listRowUploadsSlice from './listRowUploads';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        header: headerSlice.reducer,
        lc: lcSlice.reducer,
        lang: langSlice.reducer,
        workspace: workspaceSlice.reducer,
        mailbox: mailboxSlice.reducer,
        forms: formsSlice.reducer,
        builderForm: builderFormSlice.reducer,
        imageEditor: imageEditorSlice.reducer,
        formSignature: formSignatureSlice.reducer,
        lists: listsSlice.reducer,
        activeList: activeListSlice.reducer,
        listRowUploads: listRowUploadsSlice.reducer,
    }
});

export default store;